import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Professionals from './components/Professionals';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Help from './components/Help';
import Blogs from './components/Blogs';
import BlogPost from './components/BlogPost';
import DeleteAccount from './components/DeleteAccount';
import Tools from './components/Tools';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/professionals" element={<Professionals />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogPost />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/help" element={<Help />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/tools" element={<Tools />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
